/*
 * Copyright (C) 2026 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { DIALOG_DATA } from '@angular/cdk/dialog';
import { AsyncPipe } from '@angular/common';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import {
  API_SERVICE,
  ConvertProblemDetailToErrorMessagesPipe,
  createEmptyStateResource,
  StateResource,
  tapOnLoadedResource,
} from '@common/tech-shared';
import { Resource, ResourceUri } from '@ngxp/rest';
import { ButtonWithSpinnerComponent, OzgcloudDialogService } from '@odc/component';
import { ButtonComponent, ErrorMessageComponent } from '@ods/system';
import { Observable, of, Subscription } from 'rxjs';

export interface DeleteListItemDialogData {
  resourceUri: ResourceUri;
  title: string;
  subTitle?: string;
  withWarning?: boolean;
  description: string;
  deleteButtonText: string;
}

@Component({
  selector: 'administration-delete-list-item-dialog-container',
  imports: [
    ButtonComponent,
    ButtonWithSpinnerComponent,
    AsyncPipe,
    ConvertProblemDetailToErrorMessagesPipe,
    ErrorMessageComponent,
  ],
  templateUrl: './delete-list-item-dialog-container.component.html',
})
export class DeleteListItemDialogContainerComponent implements OnInit, OnDestroy {
  private readonly dialogService = inject(OzgcloudDialogService);
  private readonly apiService = inject(API_SERVICE);
  public dialogData: DeleteListItemDialogData = inject(DIALOG_DATA);

  public resourceStateResourceSub: Subscription;
  public deleteStateResource$: Observable<StateResource<Resource>> = of(createEmptyStateResource<Resource>());

  ngOnInit(): void {
    this.apiService.select(this.dialogData.resourceUri);
    this.resourceStateResourceSub = this.apiService.get().subscribe();
  }

  public delete(): void {
    this.deleteStateResource$ = this.apiService.delete().pipe(
      tapOnLoadedResource(() => {
        this.apiService.markListAsReload();
        this.closeDialog();
      }),
    );
  }

  public closeDialog(): void {
    this.dialogService.closeAll();
  }

  ngOnDestroy(): void {
    if (this.resourceStateResourceSub) this.resourceStateResourceSub.unsubscribe();
  }
}
